<template>
	<div class="common-head">
		<div class="head-box">
			<p class="system-name" @click="$router.push('/' + (ticket_type || ''))">{{base_info.system_web_name}}</p>
			<div class="menu-box" v-if="ticket_type == 'personal'">
				<p v-if="!personal_user_info.api_token && base_info.is_nouser_version == 0" @click="openLogin">登录</p>
				<p v-if="personal_user_info.api_token" @click="logOut">退出登录</p>
				<p v-if="personal_user_info.api_token || base_info.is_nouser_version == 1" @click="$router.push('/personal/record')">预约记录</p>
				<p v-if="base_info.is_haveteam_version == 1" @click="$router.push('/team/index')">团体预约</p>
			</div>
			<div class="menu-box" v-if="ticket_type == 'team'">
				<p v-if="team_login_info.api_token" @click="logOut">退出登录</p>
				<p v-if="team_login_info.api_token" @click="$router.push('/team/record/1')">{{team_login_info.username}}</p>
				<p v-if="team_login_info.api_token" @click="$router.push('/team/change/psd/1')">修改密码</p>
				<p v-if="team_login_info.api_token" @click="$router.push('/team/record/2')">历史订单</p>
				<p v-if="!team_login_info.api_token && base_info.teamuser_type_version != 5" @click="openLogin">团体登录</p>
				<p v-if="base_info.teamuser_type_version == 5" @click="$router.replace('/team/onuser/record')">订单记录</p>
				<p @click="$router.push('/personal/index')">个人预约</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { setCookie, removeAllCookie } from "@/common/js/assist"
	export default {
		computed: {
			base_info() {
				return this.$store.state.base_info
			},
			ticket_type() {
				return this.$store.state.ticket_type
			},
			team_login_info() {
				return this.$store.state.team_login_info
			},
			personal_user_info() {
				return this.$store.state.personal_user_info
			}
		},
		methods: {
			openLogin() {
				if(this.ticket_type == 'personal'){
					if(this.base_info.pc_login_show.length == 2) {
						//微信扫码登录&&邮箱验证码登录
					} else {
						if(this.base_info.pc_login_show.includes('11')) {
							//微信扫码登录
							setCookie('wx_scan_rurl', window.location.href, 5);
							window.location.href = WX_OAUTH_URL + '/wx_oauth_w'
						} else {
							//邮箱验证码登录
							this.$store.commit('show_login', true);
						}
					}
				}else if(this.ticket_type == 'team'){
					this.$store.commit('show_team_login', true);
				}
			},
			logOut() {
				if(this.$route.meta.ticketType == "team"){
					localStorage.removeItem('team_login_info');
					localStorage.removeItem('team_user_info');
					this.$store.commit('team_login_info', JSON.parse(localStorage.getItem('team_login_info')) || {});
					this.$router.push("/team/index")
				}else{
					localStorage.removeItem('personal_user_info');
					localStorage.removeItem('personal_user_info');
					removeAllCookie('.hdwbcloud.com');
					this.$store.commit('personal_user_info', JSON.parse(localStorage.getItem('personal_user_info')) || {});
					this.$router.push("/personal/index")
				}
				this.$Message.success('已退出登录');
			}
		}
	}
</script>

<style scoped lang="scss">
	@import '@/common/css/var.scss';
	.common-head {
		width: 100%;
		height: 80px;
		overflow: hidden;
		background: $base-color;
		.head-box {
			width: 1200px;
			margin: 0 auto;
			.system-name {
				font-size: 30px;
				color: #fff;
				line-height: 80px;
				float: left;
				cursor: pointer;
			}
			.menu-box {
				float: right;
				font-size: 20px;
				color: #fff;
				p {
					line-height: 24px;
					float: right;
					padding-left: 20px;
					cursor: pointer;
					margin: 26px 0 0 20px;
					border-left: 1px solid #fff;
					&:last-child {
						border: 0;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/common/components/header.vue